export default __webpack_public_path__ + "static/media/apple.4de55b87.svg";